import { postJSON, post, get } from '@/utils/axios'

// 检测列表头部统计
interface carCheckListStatisticsProps {
    startTime: any
    endTime: any
}
export const getCarCheckListStatistics = (options:carCheckListStatisticsProps) => postJSON('checkReport/carCheckListStatistics', options)


export const carCheckListStatistics = (options:carCheckListStatisticsProps) => postJSON('checkReport/v2/carCheckListStatistics', options)

// 检测列表
interface selectCarCheckListProps {
    page?: string //当前页
    orderBy?: string
    size?: string //每页大小
    queryValue?: string //车牌、手机号、姓名查询条件
    brandName?: string //品牌名称
    startTime?: string
    endTime?: string
    checkreportStatus?: string //检测报告状态 0-正常 1-密切关注 2-急需处理
    checkItemStatus?: string //检测项目状态 0-正常 1-密切关注 2-急需处理
    itemPk?: string //检测项目pk：如果检测项目状态为：密切关注或急需处理时，checkItemStatus必传
    followUpStatus?: string //跟进状态 1-待跟进 2-已跟进
    followUpStartTime?: string //跟进开始日期
    followUpEndTime?: string //跟进截止日期
    
}
export const getSelectCarCheckList = (options:selectCarCheckListProps) => postJSON('checkReport/selectCarCheckList', options)

// 更新推送车主次数
export const setUpdatePushUserNumber = (checkReportPk) => post('checkReport/updatePushUserNumber', { checkReportPk })

// 更新分享车主次数
export const setUpdateShareUserNumber = (checkReportPk) => post('checkReport/updateShareUserNumber', { checkReportPk })

// 更新车主扫码次数
export const setUpdateUserScanNumber = (checkReportPk) => post('checkReport/updateUserScanNumber', { checkReportPk })

// 更新车主扫码次数
export const setReportApproval = (checkReportPk) => post('checkReport/reportApproval', { checkReportPk })

// 更新车主扫码次数
interface problemItemListProps {
    page: string | number //当前页
    orderBy?: string
    size: string | number //每页大小
    queryValue?: string //车牌、手机号、姓名查询条件
    brandName?: string //品牌名称
    startTime?: string
    endTime?: string
    checkreportStatus?: string //检测报告状态 0-正常 1-密切关注 2-急需处理
    checkItemStatus?: string //检测项目状态 0-正常 1-密切关注 2-急需处理
    itemPk?: string //检测项目pk：如果检测项目状态为：密切关注或急需处理时，checkItemStatus必传
}
export const getProblemItemList = (options:problemItemListProps) => postJSON('checkReport/problemItemList', options)

// 按检测项目统计车辆品牌列表
interface statisticsCarCheckBrandListByCheckItemPkProps {
    checkItemStatus?: string 
    itemPk?: string //检测项目pk：如果检测项目状态为：密切关注或急需处理时，checkItemStatus必传
}
export const getBrandList = (options:statisticsCarCheckBrandListByCheckItemPkProps) => postJSON('checkReport/statisticsCarCheckBrandListByCheckItemPk', options)

// 检测报告详情
export const getCheckReportDetail = (checkReportPk) => post('checkReport/checkReportDetail', { checkReportPk })

// 检测报告头部统计
interface checkReportHeaderStatisticsProps {
    page?: string | number
    orderBy?: string
    size?: string | number
    startTime?: string
    endTime?: string
    checkUserPk?: string
    carNo?: string
    brandName?: string
    specialPk?: string
    checkreportStatus?: string
    userBehaviour?: string
    rewardMinAmount?: string
}
export const getCheckReportHeaderStatistics = (options:checkReportHeaderStatisticsProps) => postJSON('checkReport/checkReportHeaderStatistics', options)

// 检测类型统计列表
interface statisticsCarCheckTypeListProps {
    page?: string | number
    orderBy?: string
    size?: string | number
    startTime?: string
    endTime?: string
    checkUserPk?: string
    carNo?: string
    brandName?: string
    specialPk?: string
    checkreportStatus?: string
    userBehaviour?: string
    rewardMinAmount?: string
}
export const getStatisticsCarCheckTypeList = (options:statisticsCarCheckTypeListProps) => postJSON('checkReport/statisticsCarCheckTypeList', options)

// 检测报告列表
interface checkReportListProps {
    page?: string | number
    orderBy?: string
    size?: string | number
    startTime?: string
    endTime?: string
    checkUserPk?: string
    carNo?: string
    brandName?: string
    specialPk?: string
    checkreportStatus?: string
    userBehaviour?: string
    rewardMinAmount?: string
}
export const getCheckReportList = (options:checkReportListProps) => postJSON('checkReport/checkReportList', options)

// 查询本门店车辆品牌
export const getCarBrandStatistics = () => get('car/carBrandStatistics')

// 员工列表
export const getDirectSupervisor = (searchName:string = '', userStatus:string = '1') => get('/yme-system/staff/getDirectSupervisor',{searchName}, {}, false)

// 检测跟进头部统计
interface reportFollowUpHeaderStatisticsProps {
    startTime?: string
    endTime?: string
}
export const getReportFollowUpHeaderStatistics = (options:reportFollowUpHeaderStatisticsProps) => postJSON('reportFollowUp/reportFollowUpHeaderStatistics', options)

// 检测跟进列表状态统计
export const getReportFollowUpStatusStatistics = (startTime?:string, endTime?:string) => postJSON('reportFollowUp/reportFollowUpStatusStatistics', {startTime, endTime})

// 待跟进报告列表
interface selectUnFollowUpReportListProps {
    page?: string //当前页
    orderBy?: string
    size?: string
    queryValue?: string //车牌、手机号、姓名查询条件
    brandName?: string //品牌名称
    startTime?: string
    endTime?: string //截止日期
    checkreportStatus?: string //检测报告状态 0-正常 1-密切关注 2-急需处理
    checkItemStatus?: string //检测项目状态 0-正常 1-密切关注 2-急需处理
    itemPk?: string //检测项目pk：如果检测项目状态为：密切关注或急需处理时，checkItemStatus必传
    followUpStatus?: string //跟进状态 1-待跟进 2-已跟进
}
export const getSelectUnFollowUpReportList = (options:selectUnFollowUpReportListProps) => postJSON('reportFollowUp/selectUnFollowUpReportList', options)

// 跟进记录列表统计
interface followUpRecordHeaderStatisticsProps {
    page?: string | number //当前页
    orderBy?: string //排序
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    handleStatus?: string //处理状态0-未处理 1-已处理
}
export const getFollowUpRecordHeaderStatistics = (options:followUpRecordHeaderStatisticsProps) => postJSON('reportFollowUp/followUpRecordHeaderStatistics', options)

// 跟进记录列表
interface selectFollowUpRecordListProps {
    page?: string | number //当前页
    orderBy?: string //排序
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    handleStatus?: string //处理状态0-未处理 1-已处理
    checkItemStatus?: string //项目状态 0-正常 1-密切关注 2-急需处理
}
export const getSelectFollowUpRecordList = (options:selectFollowUpRecordListProps) => postJSON('reportFollowUp/selectFollowUpRecordList', options)

// 检测报告跟进
interface followUpDetailDtosItem {
    checkItemPk?: string //检测项目PK
    checkItemName?: string //检测项目名称
    followUpType?: string //跟进类型 0-待处理 1-已处理 2-放弃处理 3-预约处理 4-下次跟进
    nextFollowUpTime?: string //下次跟进时间
}

interface resourceDtosItem {
    resourceUrl?: string //资源地址
    type?: string | number //类型 0-图片 1-视频
}

interface followUpModeDtosItem {
    followUpMode?: string //跟进方式0-电话 1-微信 2-到店沟通 3-Ai智能 4-短信
    smsContent?: string //短信内容
    followUpType?: string //跟进类型 0-待处理 1-已处理 2-放弃处理 3-预约处理 4-下次跟进
    resourceDtos?: resourceDtosItem[]
}

interface reportFollowUpProps {
    checkReportPk?: string //检测报告pk
    followUpContent?: string //跟进内容
    followUpDetailDtos?: followUpDetailDtosItem[] //跟进项目列表
    followUpModeDtos?: followUpModeDtosItem[] //跟进方式列表

}
export const getReportFollowUp = (options:reportFollowUpProps) => postJSON('reportFollowUp/reportFollowUp', options)

// 检测统计
interface reportStatisticsProps {
    startTime?: string //
    endTime?: string //
}
export const getReportStatistics = (options:reportStatisticsProps) => postJSON('checkReport/reportStatistics', options)

// 检测方案产值排名
interface checkTypeRankProps {
    startTime?: string //
    endTime?: string //
    rankType?: string //排名类型 检测台数：checkNumber，开口转化：talkConversionOutputValue，跟进转化：followUpConversionOutputValue，增项转化：additionsOutputValue
    orderBy?: string //排序 DESC:降序 ASC:升序
}
export const getCheckTypeRank = (options:checkTypeRankProps) => postJSON('checkReport/checkTypeRank', options)

// 检测技师排名
interface technicianRankProps {
    startTime?: string //
    endTime?: string //
    rankType?: string //排名类型 产值：outputValue，奖励：totalReward，检测：checkReward，开口：talkReward，转化：conversionReward，跟进：followUpReward，增项：additionsReward
    orderBy?: string //排序 DESC:降序 ASC:升序
}
export const getTechnicianRank = (options:technicianRankProps) => postJSON('checkReport/technicianRank', options)


/**
 * 施工报告
 */
// 施工报告列表头部统计
interface constructionReportHeaderStatisticsProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    serviceTypePk?: string //服务类型pk
    constructionUserPk?: string //施工技师pk
    carNo?: string //车牌
    brandName?: string //品牌名称
    servicePk?: string //服务pk
    reportStatus?: string //报告状态 0-阅读 1-打赏 2-评价 3-已推送
    rewardMinAmount?: string //打赏最小金额
    rewardMaxAmount?: string //打赏最大金额
}

export const getConstructionReportHeaderStatistics = (options:constructionReportHeaderStatisticsProps) => postJSON('constructionReport/constructionReportHeaderStatistics', options)

// 施工报告列表服务类型统计
export const getStatisticsServiceTypeList = (options:constructionReportHeaderStatisticsProps) => postJSON('constructionReport/statisticsServiceTypeList', options)

// 施工报告列表
export const getSelectConstructionReportList = (options:constructionReportHeaderStatisticsProps) => postJSON('constructionReport/selectConstructionReportList', options)

// 施工报告pk查询报告详情
export const getSelectConstructionReportDetailByReportPk = (reportPk) => post('constructionReport/selectConstructionReportDetailByReportPk',{ reportPk })

// 施工单pk查询报告详情
export const getConstructionReportDetailByConstructionBillPk = (constructionBillPk) => post('constructionReport/constructionReportDetailByConstructionBillPk',{ constructionBillPk })

//施工报告门店审核
export const reportApproval = (reportPk) => post('constructionReport/reportApproval',{ reportPk })

//更新推送车主次数
export const updatePushUserNumber = (reportPk) => post('constructionReport/updatePushUserNumber',{ reportPk })

//更新分享车主次数
export const updateShareUserNumber = (reportPk) => post('constructionReport/updateShareUserNumber',{ reportPk })

//根据施工单PK查询最新延保单详情
export const getExtendedPolicyBySgPk = (sgPk) => get(`extendedPolicy/getExtendedPolicyBySgPk/${sgPk}`,{ sgPk }, { }, false)

//车主端-按施工单pk查询质保详情
export const getSelectUserWarrantyCardDetailByConstructionBillPk = (constructionBillPk) => post(`warrantyCard/selectUserWarrantyCardDetailByConstructionBillPk`,{ constructionBillPk }, { }, false)

// 服务流程查询
interface constructionProcessProps {
    itemPk?: string //施工服务PK
    orgPk?: string //门店PK
}
export const getConstructionProcess = (options:constructionProcessProps) => get(`constructionBill/constructionProcess`, options)

/**
 * 检测方案
 */

//检测方案头部数据统计
 interface checkTypeHeadStatisticsProps {
    startTime?: string //开始日期
    endTime?: string //截止日期
}
export const getCheckTypeHeadStatistics = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/checkTypeHeadStatistics`, options)

//检测方案分組统计
export const getCheckTypeGroupStatisticsVo = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/checkTypeGroupStatisticsVo`, options)

// 检测技师统计列表
export const getSelectCheckUserList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckUserList`, options)

// 检测方案统计列表
export const getSelectCheckTypeStatisticsList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckTypeStatisticsList`, options)

// 检测跟进统计列表
export const getSelectCheckFollowUpStatisticsList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckFollowUpStatisticsList`, options)

// 检测工时费统计列表
export const getSelectCheckTypeCostStatisticsList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckTypeCostStatisticsList`, options)

// 检测方案阅读统计列表
export const getSelectCheckTypeReadStatisticsList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckTypeReadStatisticsList`, options)

// 检测方案评价统计列表
export const getSelectCheckTypeEvaluateStatisticsList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckTypeEvaluateStatisticsList`, options)

// 检测方案打赏统计列表
export const getSelectCheckTypeRwardStatisticsList = (options:checkTypeHeadStatisticsProps) => postJSON(`checkSpecialType/selectCheckTypeRwardStatisticsList`, options)

// 检测方案列表状态栏统计
export const getSelectCheckTypeListHeadStatistics = () => postJSON(`checkSpecialType/selectCheckTypeListHeadStatistics`)

// 检测方案列表
interface selectCheckTypeListProps {
    page?: number
    size?: number //每页大小
    status?: number | string //状态0-禁用 1-启用 2-下载 3-未下载
}
export const getSelectCheckTypeList = (options:selectCheckTypeListProps) => postJSON(`checkSpecialType/selectCheckTypeList`, options)

// 更新启用/停用状态
interface updateStatusProps {
    specialPk: number | string //检测类型pk
    status: number | string //状态0-停用 1-启用
}
export const setUpdateStatus = (options:updateStatusProps) => post(`checkSpecialType/updateStatus`, options)

//下载云检测方案
export const getDownloadCloudCheckSpecialType = (cloudPk: string) => post(`checkSpecialType/downloadCloudCheckSpecialType`, { cloudPk })

/**
 * 进店记录
 */
//根据车牌号统计消费记录
export const getConsumeStatistics = (carNo: string) => post(`pickCar/consumeStatistics`, { carNo })

interface consumeDetailProps {
    carNo: string
    page: string | number
    size: string | number
    typePk: string
}

export const getConsumeDetail = (options: consumeDetailProps) => postJSON(`pickCar/consumeDetail`, options)

//根据车牌号查询历史导入消费明细列表
interface selectHistoryConsumeListProps {
    carNo?: string
    page?: string | number
    size?: string | number
    searchValue?: string
}
export const selectHistoryConsumeList = (options: selectHistoryConsumeListProps) => postJSON(`pickCar/selectHistoryConsumeList`, options)

/**
 * 分享文案
 */

interface selectShareCopywritingProps {
    bizPk?: string //检测方案pk/施工项目pk
    bizType?: string //业务类型 0-检测报告 1-施工报告
    content?: string //文案内容
}
//保存分享文案
export const saveShareCopywriting = (options:selectShareCopywritingProps) => post(`shareCopywritingCfg/saveShareCopywriting`, options)

//查询门店分享文案内容
export const selectShareCopywriting = (options:selectShareCopywritingProps) => post(`shareCopywritingCfg/selectShareCopywriting`, options)

/**
 * 检测英雄排行榜
 */

//英雄排行榜-本店检测排名
interface currentOrgCheckRankProps {
    page?: string | number //当前页
    size?: string | number //每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
}
export const getCurrentOrgCheckRank = (options: currentOrgCheckRankProps) => postJSON(`checkReport/currentOrgCheckRank`, options)

//英雄排行榜-区域门店检测排名
export const getOrgCheckRank = (options: currentOrgCheckRankProps) => postJSON(`checkReport/orgCheckRank`, options)

//英雄排行榜-当前技师检测排名
export const getCurrentTechnicianCheckRank = (options: currentOrgCheckRankProps) => postJSON(`checkReport/currentTechnicianCheckRank`, options)

//英雄排行榜-技师检测排名
export const getTechnicianCheckRank = (options: currentOrgCheckRankProps) => postJSON(`checkReport/technicianCheckRank`, options)


/**
 * 新施工报告
 *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * 
 */

//接车单pk查询报告详情
export const selectMergeReportByReceiveBillPk = (receiveBillPk: string) => post(`mergeReport/selectMergeReportByReceiveBillPk`, { receiveBillPk })

//施工报告pk查询报告详情
export const selectMergeReportByConstructionBillPk = (constructionBillPk: string | number) => post(`mergeReport/selectMergeReportByConstructionBillPk`, { constructionBillPk })

//添加施工报告阅读记录
interface insertReadRecordProps {
    reportPk?: string //工单总报告pk
    userPk?: string //阅读人pk
}
export const insertReadRecord = (options: insertReadRecordProps) => post(`mergeReport/insertReadRecord`, options)

//施工报告门店审核
export const mergeReportReportApproval = (reportPk: string) => post(`mergeReport/reportApproval`, { reportPk })

//更新推送车主次数
export const mergeReportUpdatePushUserNumber = (reportPk: string) => post(`mergeReport/updatePushUserNumber`, { reportPk })


//更新分享车主次数
export const mergeReportUpdateShareUserNumber = (reportPk: string) => post(`mergeReport/updateShareUserNumber`, { reportPk })

// 工单报告列表头部统计
interface constructionReportHeaderStatisticsProps {
    page?: string | number //当前页
    size?: string | number//每页大小
    startTime?: string //开始日期
    endTime?: string //截止日期
    serviceTypePk?: string //服务类型pk
    constructionUserPk?: string //施工技师pk
    carNo?: string //车牌
    brandName?: string //品牌名称
    servicePk?: string //服务pk
    reportStatus?: string //报告状态 0-阅读 1-打赏 2-评价 3-已推送
    orgApprovalStatus?: string //报告审核状态0-否 1-是
    rewardMinAmount?: string //打赏最小金额
    rewardMaxAmount?: string //打赏最大金额
}
export const constructionReportHeaderStatistics = (options: constructionReportHeaderStatisticsProps) => postJSON(`mergeReport/constructionReportHeaderStatistics`, options)

// 工单报告列表服务类型统计
export const statisticsServiceTypeList = (options: constructionReportHeaderStatisticsProps) => postJSON(`mergeReport/statisticsServiceTypeList`, options)

// 工单报告列表
export const selectConstructionReportList = (options: constructionReportHeaderStatisticsProps) => postJSON(`mergeReport/selectConstructionReportList`, options)

// 根据车牌号查询它店消费明细记录
interface selectOtherStoreConsumeDetailListProps {
    page?: any //当前页
    carNo?: any //车牌号
    size?: any //每页大小
    typePk?: any //服务大类pk
}
export const selectOtherStoreConsumeDetailList = (options:selectOtherStoreConsumeDetailListProps) => postJSON(`pickCar/selectOtherStoreConsumeDetailList`, {
    ...options,
})

// 根据车牌号查询它店消费类型列表
export const selectOtherStoreConsumeTypeList = (options:selectOtherStoreConsumeDetailListProps) => postJSON(`pickCar/selectOtherStoreConsumeTypeList`, {
    ...options,
})

// 根据车牌号查询本店消费类型列表
export const selectStoreConsumeTypeList = (serviceName:string, carNo: string) => postJSON(`pickCar/selectStoreConsumeTypeList`, {
    serviceName,
    carNo
})